import { __assign } from "tslib";
import { ATDealersLinks, ATGroupLinks } from '../footer-shared-links';
export var FooterVansLinks = function () {
    return [
        __assign({}, ATGroupLinks),
        {
            rowHeading: 'Services',
            subNav: [
                {
                    url: '/vans/insurance',
                    displayText: 'Van insurance',
                    routerLink: false,
                },
                {
                    url: '/vans/finance',
                    displayText: 'Van finance',
                    routerLink: false,
                },
                {
                    url: '/vans/vehicle-check',
                    displayText: 'Vehicle check',
                    routerLink: false,
                },
                {
                    url: '/vans/finance/calculator',
                    displayText: 'Finance calculator',
                    routerLink: false,
                },
            ],
        },
        {
            rowHeading: 'Private customers',
            subNav: [
                {
                    url: '/vans/sell',
                    displayText: 'Sell my van',
                    routerLink: false,
                },
                {
                    url: '/vans/sell-my-van/advertising-prices',
                    displayText: 'Advertising costs',
                    routerLink: false,
                },
                {
                    url: '/safety_and_security_centre',
                    displayText: 'Buying & selling safely online',
                    routerLink: false,
                },
                {
                    url: '/terms-and-conditions/advertising',
                    displayText: 'Terms & conditions',
                    routerLink: false,
                },
            ],
        },
        {
            rowHeading: 'Quick search',
            subNav: [
                {
                    url: '/vans/used-vans/browse-all-makes',
                    displayText: 'All vans makes',
                    routerLink: false,
                },
                {
                    url: '/vans/content',
                    displayText: 'Van reviews',
                    routerLink: false,
                },
                {
                    url: '/vans/van-dealers',
                    displayText: 'Van dealers',
                    routerLink: false,
                },
            ],
        },
        __assign({}, ATDealersLinks),
    ];
};
export default FooterVansLinks;
